var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid/Communication/Contacts"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4564 2.88252C13.5006 2.45778 10.4993 2.45778 7.54347 2.88252C6.07798 3.09311 4.94888 4.2825 4.81475 5.75696L4.68779 7.15269C4.39444 10.3775 4.39444 13.6222 4.68779 16.847L4.81475 18.2427C4.94888 19.7172 6.07798 20.9066 7.54347 21.1172C10.4993 21.5419 13.5006 21.5419 16.4564 21.1172C17.9219 20.9066 19.051 19.7172 19.1851 18.2427L19.3121 16.847C19.6055 13.6222 19.6055 10.3775 19.3121 7.15269L19.1851 5.75695C19.051 4.2825 17.9219 3.09311 16.4564 2.88252ZM9.99994 8.99985C9.99994 7.89528 10.8954 6.99985 11.9999 6.99985C13.1045 6.99985 13.9999 7.89528 13.9999 8.99985C13.9999 10.1044 13.1045 10.9998 11.9999 10.9998C10.8954 10.9998 9.99994 10.1044 9.99994 8.99985ZM7.99994 15.4998C7.99994 13.843 9.34308 12.4998 10.9999 12.4998H12.9999C14.6568 12.4998 15.9999 13.843 15.9999 15.4998C15.9999 16.0521 15.5522 16.4998 14.9999 16.4998H8.99994C8.44765 16.4998 7.99994 16.0521 7.99994 15.4998Z",
    fill: "#0E6AF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusAdmin);
export default __webpack_public_path__ + "static/media/plus_admin.60397bed1efaf454365acd6ebcbaac93.svg";
export { ForwardRef as ReactComponent };